import React from 'react'
import Empty from './empty'
import ListItem from './item'
import FilterList from './filter'
import PrimaryListWrapper from './primary-list-wrapper'

const ListDisplay = ({
  records = [],
  currentRecordID,
  base_url,
  component,
  primaryKey,
  filterDisabled,
  filterTerm,
  filterOnChange
}) => (
  <PrimaryListWrapper>
    <FilterList
      show={!filterDisabled}
      term={filterTerm}
      onChange={filterOnChange}
    />
    {
      records.length === 0 ?
        <Empty /> :
        <ul>
          {records.map(record => (
            <ListItem
              key={`row-${primaryKey(record)}`}
              selected={String(primaryKey(record)) === String(currentRecordID)}
              record={record}
              base_url={base_url}
              component={component}
              primaryKey={primaryKey}
            />
          )
          )}
        </ul>
    }
  </PrimaryListWrapper>
)

export default ListDisplay


// WEBPACK FOOTER //
// ./src/ui/list/views/display.jsx